
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-to-join",
      function () {
        return require("private-next-pages/request-to-join.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-to-join"])
      });
    }
  